<template>
  <div>
    <el-dialog
      :title="eltitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal = "false"
      width="640px"
      :before-close="returnClick">
      <el-row style="width: 626px;box-sizing: border-box;max-height: 595px;overflow:auto;">
        <div class="seaerch-wrapper">
          <el-form :model="modalInfo.form" :rules="rules" ref="ruleForm" class="add-form" label-position="right"  label-width="130px">
            <div style="font-weight: bold;margin-bottom: 20px">
              店铺信息
            </div>
            <el-form-item label="平台" prop="platform_code" >
              <el-select v-model="modalInfo.form.platform_code" placeholder="请选择" size="small" clearable>
                <el-option
                  v-for="item in modalInfo.plateform"
                  :key="item.dictCode"
                  :value="item.dictCode"
                  :label="item.dictName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="店铺名称"  prop="shop_name" >
              <div style="display: flex;">
                <el-input v-model.trim="modalInfo.form.shop_name" size="small" placeholder="请输入" clearable></el-input>
                <el-button type="primary" @click="getBlackListPageByBmcNormal" size="mini" style="height: 32px;margin-left: 10px;margin-top: 5px;" :loading="shopLoading" v-if="userData.logintype=='KEFU'">匹配信息</el-button>
              </div>
            </el-form-item>
            <el-form-item  v-if="isExitWangwang(modalInfo.form.platform_code)?true:false" label="旺旺" prop="wangwang" >
              <el-input v-model.trim="modalInfo.form.wangwang" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="店铺首页地址"  prop="shop_url" >
              <el-input v-model.trim="modalInfo.form.shop_url" size="small" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="店铺类目"  prop="shopcategory" v-if="shoptype == '2'">
              <el-input v-model.trim="modalInfo.form.shopcategory" size="small" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="发货地址"  prop="shippingaddress" v-if="shoptype == '2'">
              <el-input v-model.trim="modalInfo.form.shippingaddress" size="small" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="店铺运营负责人"  prop="shopoperate" >
              <el-input v-model.trim="modalInfo.form.shopoperate" size="small" placeholder="请输入"></el-input>
            </el-form-item>
    		    <el-form-item label="店铺运营联系方式"  prop="shopoperatecontact" >
              <el-input v-model.trim="modalInfo.form.shopoperatecontact" size="small" placeholder="请输入"></el-input>
            </el-form-item>

            <div style="font-weight: bold;margin-bottom: 20px" v-if="shoptype == '2'">
              企业信息
            </div>
            <el-form-item label="公司名称"  prop="companyname" >
              <el-input v-model.trim="modalInfo.form.companyname" size="small" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="法人名称"  prop="corporatename" >
              <el-input v-model.trim="modalInfo.form.corporatename" size="small" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="法人联系方式"  prop="corporatephone" >
              <el-input v-model.trim="modalInfo.form.corporatephone" size="small" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="营业执照地址"  prop="corporatephone" >
              <v-distpicker :province="modalInfo.form.province" :city="modalInfo.form.city" :area="modalInfo.form.district"
                @province="onChangeProvince" @city="onChangeCity" @area="onChangeArea"
                style="height: 32px;width: 375px;margin-bottom: 20px;"
              ></v-distpicker>
              <el-input v-model.trim="modalInfo.form.businesslicenseaddress" size="small" placeholder="请输入详细地址自动解析" @blur="parseAddress"></el-input>
            </el-form-item>


            <div style="font-weight: bold;margin-bottom: 20px">
              经销商信息
            </div>
    		    <el-form-item label="开店经销商" prop="dealerid" id="autocomplete">
      			<!-- <el-select  v-model="modalInfo.form.dealerid" value-key="id" @change="getDealername" filterable placeholder="请选择" size="small" clearable >
      			<el-option
      				v-for="item in dealernameList"
      				:key="item.id"
      				:value="item.id"
      				:label="item.dealername"
      			></el-option>
      			</el-select> -->
              <el-autocomplete
                v-model="modalInfo.form.dealername"
                :fetch-suggestions="querySearch"
                placeholder="请输入内容"
                @select="handleSelect"
                @change="changeSelect"
                size="small"
              ></el-autocomplete>
      			<!-- <el-button size="small" @click="linkAddDealername" class="addBtn">新增经销商</el-button> -->
    		</el-form-item>
    		<el-form-item label="供货经销商" prop="supplydealerid">
    			<el-select  v-model="modalInfo.form.supplydealerid" value-key="id" filterable placeholder="请选择" size="small" multiple clearable >
    			<el-option
    				v-for="item in dealernameList"
    				:key="item.id"
    				:value="item.id"
    				:label="item.dealername"
    			></el-option>
    			</el-select>
    		</el-form-item>
    		<el-form-item label="业务人员"  prop="businesspeople" >
              <el-input v-model.trim="modalInfo.form.businesspeople" size="small" placeholder="请输入"></el-input>
            </el-form-item>
    		<el-form-item label="业务人员联系方式"  prop="businesspeoplecontact" >
              <el-input v-model.trim="modalInfo.form.businesspeoplecontact" size="small" placeholder="请输入"></el-input>
            </el-form-item>
    		
    		<el-form-item label="经销商负责人"  prop="dealeroperate" >
              <el-input v-model.trim="modalInfo.form.dealeroperate" size="small" placeholder="请输入"></el-input>
            </el-form-item>
    		<el-form-item label="经销商联系方式"  prop="dealeroperatecontact" >
              <el-input v-model.trim="modalInfo.form.dealeroperatecontact" size="small" placeholder="请输入"></el-input>
            </el-form-item>
    		<el-form-item label="备注"  prop="remark" >
              <el-input v-model.trim="modalInfo.form.remark" size="small" placeholder="请输入"></el-input>
            </el-form-item>
        </el-form>
        </div>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" :class="modalInfo.ispanelEdit?'':'confirm'"  @click="confirmClick()">确 定</el-button>
        <el-button size="small" :class="modalInfo.ispanelEdit?'':'cancel'" @click="returnClick">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="匹配信息"
      :visible.sync="pipeiShow"
      width="800px">
      <div style="padding: 20px;">
        <el-table
        :data="tableData"
        style="width: 100%">
          <el-table-column prop="platformname" label="平台"></el-table-column>
          <el-table-column prop="shop_name" label="店铺名称"></el-table-column>
          <el-table-column prop="wangwang" label="旺旺名称"></el-table-column>
          <el-table-column prop="shop_url" label="店铺首页地址"></el-table-column>
          <el-table-column prop="dealername" label="开店经销商"></el-table-column>
          <el-table-column prop="supplydealername" label="供货经销商"></el-table-column>
          <el-table-column prop="corporatename" label="法人名称"></el-table-column>
          <el-table-column prop="corporatephone" label="法人联系方式"></el-table-column>
          <el-table-column prop="businesslicenseaddress" label="营业执照地址"></el-table-column>
          <el-table-column prop="businesspeople" label="业务人员"></el-table-column>
          <el-table-column prop="businesspeoplecontact" label="业务联系方式"></el-table-column>
          <el-table-column prop="shopoperate" label="店铺运营负责人"></el-table-column>
          <el-table-column prop="shopoperatecontact" label="店铺运营联系方式"></el-table-column>
          <el-table-column prop="dealeroperate" label="经销商负责人"></el-table-column>
          <el-table-column prop="dealeroperatecontact" label="经销商联系方式"></el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" type="text" size="small">选择</el-button>
            </template>
          </el-table-column>

        </el-table>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="pipeiShow = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {fetchGet,fetchPost} from "@/libs/reqCommon";
import AddressParse from 'address-parse';
import VDistpicker from 'v-distpicker'; //地区控件
import {mapState,mapActions} from 'vuex';
import axios from "axios";
export default {
    name:'AddNewModel',
    components: { VDistpicker },
    props:{
      modalInfo:{
          type:Object,
          default:() =>{}
      },
      shoptype: {
        type: String
      },
    },
    data(){
      return {
        pipeiShow: false,
        tableData: [],
        shopLoading: false,
        dialogVisible: false,
        eltitle: '',
        restaurants: [],
        rules: {
			    // dealerid:[{required: true, message: '开店经销商不能为空', trigger: 'change'}],
          platform_code: [{ required: true, message: '平台不能为空', trigger: 'change' }],
          shop_name: [{ required: true, message: '店铺名称不能为空', trigger: 'blur' }],
          wangwang: [{ required: true, message: '旺旺名称不能为空', trigger: 'blur' }],
        },
        imageUrl: '',
        uploadPicHtpp:[],
        beformuploadPicHtpp:[],
        userData:{},
      }
	},
	computed:{
		...mapState({
			dealernameList: state => state.commonList.dealernameList
		}),
	},
  mounted() {
    const userData=JSON.parse(localStorage.getItem('userData'));//获取用户信息
    this.userData=userData
  },
	created(){
		this.reqDealernameList(null);
    
	},
  methods:{
    parseAddress() {
      /*判断解析的地址内容不为空*/
      if (this.modalInfo.form.businesslicenseaddress != '') {
        const result = AddressParse.parse(this.modalInfo.form.businesslicenseaddress);
        console.log(result)
        this.modalInfo.form.province = result[0].province
        this.modalInfo.form.city = result[0].city
        this.modalInfo.form.district = result[0].area
        this.modalInfo.form.businesslicenseaddress = result[0].details
      } else {
        this.$message({
          message: '请输入您要识别的地址',
          type: 'warning'
        });
      }
    },
    handleClick(data) {
      this.modalInfo.form = data
      this.pipeiShow = false
    },
    getBlackListPageByBmcNormal() {
      this.shopLoading = true
      let params = {
        shopname: this.modalInfo.form.shop_name,
        pageNo:1,
        pageSize:10
      }
      fetch({
        url: "hcm/hcmShop/getBlackListPageByBmcNormal",
        method: "get",
        params: params,
      }).then((res) => {
        if (res.status == "10000") {
          this.shopLoading = false
          this.tableData = res.data.content
          this.pipeiShow = true
        }
      });
    },
    // 地区选区取值(省)
    onChangeProvince(a){
      // this.$set(this.modalInfo.form,"selectAddress",a.value)
      this.modalInfo.form.province = a.value;
      
    },
    onChangeCity(a){ //(市)
      console.log(this.modalInfo.form)
      this.modalInfo.form.city = a.value;
    },
    onChangeArea(a){  //(区)
      this.modalInfo.form.district = a.value;
    },
    ntm(val) {
      this.eltitle = val
      this.dialogVisible = true
    },
    // input可选择组件赋值
    handleSelect(item) {
      this.modalInfo.form.dealerid = item.id
    	this.modalInfo.form.dealername = item.dealername;
    },
    changeSelect() {
      this.modalInfo.form.dealerid = ''
    },
    // input可选择组件赋值
    querySearch(queryString, cb) {
      this.restaurants = this.dealernameList
      for (let i in this.restaurants) {
        this.restaurants[i].value = this.restaurants[i].dealername
      }
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    // input可选择组件赋值
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
	  ...mapActions(["reqDealernameList"]),
	  // 获取经销商名称和dealerid
    // getDealername(val){
    // 	let obj = {};
  	// 	obj = this.dealernameList.find((item)=>{
  	// 		return item.id === val;
  	// 	});
  	// 	this.modalInfo.form.dealerid = val;
  	// 	this.modalInfo.form.dealername = obj.dealername;
  	//  },
    // 判断平台下的旺旺是否展示
    isExitWangwang(plateform){
      let exitPlatform = ["TB","TM",'1688','SMT','ALST','XY']
      for (let item of exitPlatform) if (item == plateform) return true;
      return false;
    },
    // 删除对象属性
    delProp(obj, keys) {
        keys.map(function(key) {
            delete obj[key]
        })
        return obj
    },
    // 取消
    returnClick(){
      this.$refs.ruleForm.resetFields();
      this.dialogVisible = false
      this.modalInfo.isShow = false;
      this.$emit("getIsshow",this.modalInfo.isShow);
      this.$emit("showEdit",false);
    },
    // 确认
    confirmClick(){
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let query = {
            shoptype:this.modalInfo.shoptype,
            ...this.modalInfo.form,
            platformCode:this.modalInfo.form.platform_code,
            shopName:this.modalInfo.form.shop_name,
            shopUrl:this.modalInfo.form.shop_url,
            supplydealerid:String(this.modalInfo.form.supplydealerid)
          }
          query = this.delProp(query,['platform_code','shop_name','shop_url'])//删除属性
          this.reqNewAdd(query);
        } else {
          return false;
        }
      });
    },
    // 新增/编辑请求
    reqNewAdd(query){
      fetchPost("/hcm/hcmShop/saveHcmShopByBlacklist",query).then(res => {
        if(res.status == '10000'){
          this.$message({
            message: '操作成功！',
            type: res.message
          })
          this.dialogVisible = false
          this.modalInfo.isShow = false;
          this.$emit("reqTableData");
          this.$emit("showEdit",false);
          this.$emit('reqDetail',this.modalInfo.row)
        }else{
          this.$message.error(res.message?res.message:'操作失败！');
        }
      })
    },
    // 图片上传
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 20;
        if (!isLt2M) {
            this.$message.error('上传图片大小不能超过20M!');
            return false;
        }
    },
    picRequest(a){
      //图片上传
      if(this.beformuploadPicHtpp.length>9){
          this.$message({type: 'warning', message: '最多只能上传9张截图'})
          return false
      }
      this.beformuploadPicHtpp.push(1)//本地用来判断上传的图片数量
      let that = this;
      var formdata=new FormData()
      formdata.append('file',a.file)
      const instance=axios.create({
        headers:{
          "Content-Type": "multipart/form-data"
        },
        timeout: (60 * 1000)*5,
      })
      instance.post("hcm/hcmWorkOrder/headImgUpload",formdata).then(function(res) {
        let {data}=res
        that.imgUrl = data.data.data;
        that.uploadPicHtpp.push(that.imgUrl)//http格式的图片地址
      });
    },
    deletePic(index){
      //图片删除
      this.uploadPicHtpp.splice(index,1);
      this.beformuploadPicHtpp.splice(index,1);
	  },
	  linkAddDealername(){
		  this.$router.push({path:"/ClientCheck/:id",query:{isClicked:"add"}})
	  }
  }
}
</script>
<style lang="scss">
.el-dialog__body {
  padding-top: 10px !important;
  padding-bottom: 0px;
  padding-left: 0px;
  padding-right: 0px;
}
  #autocomplete {
    .el-input--small .el-input__inner {
      height: 32px;
      line-height: 32px;
      width: 425px;
    }
  }
 .screenshot{
    display:flex;
    flex-wrap: wrap;
    .avatar-uploader{
        background: #f7f8f8;
        border:1px dashed #b5b5b5;
    }
    &>div{
        width: 119px;
        height: 119px;
        border-radius: 6px;
        margin-right: 40px;
        position: relative;
        text-align: center;
        margin-bottom: 30px;
    }
    .add_photo{
        border:1px dashed #b5b5b5;
        text-align: center;
    }
    .el-icon-plus{
        color:#bfbfbf;
        font-size: 40px;
        margin-top: 25px;
    }
    .screenshot_pic{
        width: 100%;
        height: 100%;
    }
    .el-icon-error {
        font-size:24px;
        color:#d81e06;
        position: absolute;
        top:-4px;
        right: -3px;
        cursor: pointer;
    }
}
.add-form{
	.addBtn{
		position: absolute;
		top: 5px;
		margin-left: 5px;
	}
}
</style>
